import { getDomPromise } from '../interruptiblePromises'
import { evaluateXpath } from '../interruptibleXpath'
import { NeedsUserInputError } from '../needsInputError'

export const FACEBOOK_PASSWORD_PROMPT_EXCEPTION_NAME =
  'FacebookPasswordPromptException'

export class FacebookPasswordPromptException extends Error {
  constructor(message) {
    super(message)
    this.name = FACEBOOK_PASSWORD_PROMPT_EXCEPTION_NAME
  }
}

export function getPasswordPrompt(node) {
  return evaluateXpath(node, "//input[@type = 'password']")[0]
}

async function getIsPasswordPromptOnScreen(): Promise<void> {
  await getDomPromise(document, (node) => Boolean(getPasswordPrompt(node)))

  throw new FacebookPasswordPromptException(
    'Facebook needs your password before it can continue',
  )
}

export function facebookDetectPasswordPromptWrapper<T extends Array<any>, U>(
  fn: (...args: T) => Promise<U>,
): (...args: T) => Promise<U> {
  async function wrappedFn(...args: T): Promise<U> {
    const originalPromise = fn(...args)

    // NOTE: The password prompt error can be thrown here or in the underlying
    // promise, from fbContentUtils. Overriding the error here handles both cases.
    await Promise.race([originalPromise, getIsPasswordPromptOnScreen()]).catch(
      (error) => {
        if (error instanceof FacebookPasswordPromptException) {
          throw new NeedsUserInputError(
            'Facebook needs your password before it can continue',
          )
        } else {
          throw error
        }
      },
    )

    return originalPromise
  }

  return wrappedFn
}
